export default class MainNav {

    constructor() {
        this.toggle = $('.menu-toggle');
        this.items = $('.main-nav-item:not(.news)');
        this.toggledElements = $("header, .main-nav, .mobile-nav, .header-gradient, .menu-toggle");
        this.isOpen = false;
        this.DOMBody = $('body');
        this.setEventListeners();
    }

    setEventListeners() {
        // Function prevents double click on hamburger
        this.toggle.on('click',(e) => {
            var $el = $(e.currentTarget);
            if ($el.data('clicked')) {
                // Previously clicked, stop actions
                e.preventDefault();
                e.stopPropagation();
            }
            else {
                // Set timing based on mobile/desktop
                let timing = ($(window).width() > 767) ? 1000 : 500;
                // Mark to ignore next click
                $el.data('clicked', true);
                // Run function to open nav
                this.toggleNav(e);
                // Unmark after 1 second
                window.setTimeout(function(){
                    $el.removeData('clicked');
                }, timing);
            }
        });

        this.items.on('click', this.setActiveState);
    }

    /**
     * Set a clicked nav item as active
     * - prevents the flash of un-hovered active
     * nav item
     */
    setActiveState() {
        $(this).addClass('active');
    }

    /**
     * Show main navs (mobile too)
     * @param e
     */
    toggleNav(e) {
        e.preventDefault();
        // Un-activate all columns
        this.items.removeClass('active');
        (this.isOpen) ? this.close() : this.open();
    }

    /**
     * Close main navs
     */
    close() {
        this.toggledElements.addClass('close');
        this.toggle.removeClass('open');

        // Reset the past scroll position
        let scrollPos = this.DOMBody.attr('data-scroll');
        this.DOMBody.removeClass('fixed');
        $(window).scrollTop(scrollPos);

        if ($(window).width() > 768) {
            // Wait for 1 second to reset navigation hover effects
            setTimeout(() => {
                this.toggledElements.removeClass('open').removeClass('close');
                this.isOpen = false;
                this.items.removeClass('active');
            }, 1000);
        }
        else {
            this.toggledElements.removeClass('open').removeClass('close');
            this.isOpen = false;
            this.items.removeClass('active');
            // Hide mobile subnav when nav is closed
            window.MobileNav.closeSecondary();
            // Disable iNoBounce so rest of page can scroll;
            window.App.bounceScroll('disable'); 
        }
    }


    /**
     * Open the main nav
     */
    open() {
        this.toggledElements.removeClass('close').addClass('open');
        this.isOpen = true;

        // If we are showing the mobile nav,
        // lets call the iNoBounce script to fix the ios issue
        // of the mobile nav getting stuck - thanks to the rubber band bounce effect
        window.App.bounceScroll('enable');

        // Prevent scrolling of body when nav is open
        $(".mobile-nav-wrapper").scrollTop(0);
        // animTime = the timing of the navigation sliding into video
        let animTime = ($(window).width() > 768) ? 1000 : 400;
        // Capture current screen position
        let scrollTop = $(window).scrollTop();
        // Fix the body to prevent content scrolling after the
        // animation has ran
        setTimeout(() => {
            this.DOMBody.addClass('fixed').attr('data-scroll', scrollTop);
        }, animTime);    // 1s is main nav slide in animation length
    }
}


// WEBPACK FOOTER //
// ./public/js/MainNav.js